export const SOURCES = [
  {
    key: 'remoteNode',
    label: 'input.node',
    target: 'node',
    rank: 1,
    group: 'remote',
    semverOnly: true,
    placeholder: '18 / ^18.20 / >=18 <21 / *',
  },
  {
    key: 'remotePackageManager',
    label: 'input.packageManager',
    target: 'pm',
    rank: 2,
    group: 'remote',
    semverOnly: true,
    placeholder: 'pnpm@^10 / npm@>=9 <11 / yarn@*',
  },
  {
    key: 'packageManager',
    label: 'package.json.packageManager',
    target: 'pm',
    rank: 3,
    group: 'project',
    placeholder: 'pnpm@10.21.0',
  },
  {
    key: 'pnpmLock',
    label: 'pnpm-lock.yaml',
    target: 'lock',
    manager: 'pnpm',
    rank: 4,
    group: 'lock',
    placeholder: '9.0',
  },
  {
    key: 'pnpmShrinkwrap',
    label: 'shrinkwrap.yaml',
    target: 'lock',
    manager: 'pnpm',
    rank: 5,
    group: 'lock',
    placeholder: '3 / 4',
  },
  {
    key: 'yarnLock',
    label: 'yarn.lock',
    target: 'lock',
    manager: 'yarn',
    rank: 6,
    group: 'lock',
    placeholder: 'v1 / 4 / 6 / 8 / 10',
  },
  {
    key: 'shrinkwrap',
    label: 'npm-shrinkwrap.json',
    target: 'lock',
    manager: 'npm',
    rank: 7,
    group: 'lock',
    placeholder: '1 / 2 / 3',
  },
  {
    key: 'npmLock',
    label: 'package-lock.json',
    target: 'lock',
    manager: 'npm',
    rank: 8,
    group: 'lock',
    placeholder: '1 / 2 / 3',
  },
  {
    key: 'voltaNode',
    label: 'package.json.volta.node',
    target: 'node',
    rank: 9,
    group: 'other',
    placeholder: '20.19.2',
  },
  {
    key: 'voltaPnpm',
    label: 'package.json.volta.pnpm',
    target: 'pm',
    manager: 'pnpm',
    rank: 9,
    group: 'other',
    placeholder: '9.15.4',
  },
  {
    key: 'voltaYarn',
    label: 'package.json.volta.yarn',
    target: 'pm',
    manager: 'yarn',
    rank: 9,
    group: 'other',
    placeholder: '1.22.22',
  },
  {
    key: 'voltaNpm',
    label: 'package.json.volta.npm',
    target: 'engine',
    manager: 'npm',
    rank: 9,
    group: 'other',
    placeholder: '10.8.2',
  },
  { key: 'nodeVersion', label: '.node-version', target: 'node', rank: 10, group: 'other', placeholder: '20' },
  { key: 'nvmrc', label: '.nvmrc', target: 'node', rank: 11, group: 'other', placeholder: '18 / v18.20.8 / lts/*' },
  {
    key: 'toolVersions',
    label: '.tool-versions → nodejs',
    target: 'node',
    rank: 12,
    group: 'other',
    placeholder: 'nodejs 20.19.2',
  },
  {
    key: 'devRuntime',
    label: 'devEngines.runtime → node.version',
    target: 'node',
    rank: 13,
    group: 'other',
    placeholder: '>=18 <23',
  },
  {
    key: 'devPackageManager',
    label: 'devEngines.packageManager',
    target: 'pm',
    rank: 14,
    group: 'other',
    placeholder: 'pnpm@>=9 <11',
  },
  {
    key: 'enginesNode',
    label: 'package.json.engines.node',
    target: 'node',
    rank: 15,
    group: 'other',
    placeholder: '>=18 <21',
  },
  {
    key: 'enginesNpm',
    label: 'package.json.engines.npm',
    target: 'engine',
    manager: 'npm',
    rank: 16,
    group: 'other',
    placeholder: '>=9 <11',
  },
  {
    key: 'enginesPnpm',
    label: 'package.json.engines.pnpm',
    target: 'engine',
    manager: 'pnpm',
    rank: 16,
    group: 'other',
    placeholder: '>=9 <11',
  },
  {
    key: 'enginesYarn',
    label: 'package.json.engines.yarn',
    target: 'engine',
    manager: 'yarn',
    rank: 16,
    group: 'other',
    placeholder: '^4.0.0',
  },
]

export const EMPTY_FIELDS = Object.fromEntries(SOURCES.map((s) => [s.key, '']))
